import React from 'react';
import PropTypes from 'prop-types';
import { SpinnerDotted } from 'spinners-react';

/** Inline spinner for buttons and compact actions (not full-page loading). */
function ButtonLoader({
  size = 20,
  color = '#ffffff',
  className = 'me-2',
  thickness = 100,
  speed = 100,
  style,
}) {
  return (
    <SpinnerDotted
      size={size}
      thickness={thickness}
      speed={speed}
      color={color}
      className={className}
      style={style}
    />
  );
}

ButtonLoader.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  className: PropTypes.string,
  thickness: PropTypes.number,
  speed: PropTypes.number,
  style: PropTypes.object,
};

export default ButtonLoader;
